import { Store } from '@abstractTypes/graphqlTypes'
import { StoreContext } from '@providers/storeProvider'
import { useContext } from 'react'

export const useStoreContext = (): Store => {
  const { store } = useContext(StoreContext)
  return store
}
